import { action, select } from 'satcheljs/lib/legacy';
import store from '../store/store';
export default select({
    optionState: function () { return store; },
})(action('discardPopOption')(function discardPopOption(state) {
    state.optionState.popEnabled = null;
    state.optionState.popMessageDeleteEnabled = null;
}));
//# sourceMappingURL=discardPopOption.js.map